import isEqualBounds from 'src/js/modules/common/helpers/is-equal-bounds';
import { getMedia, getIframe } from './get-media';
import matchesMedia from './matches-media';

const matchesIframeMedia = (element) => {
  const isMediaWithIframe = matchesMedia(element) && Boolean(getIframe(element));

  if (isMediaWithIframe) {
    return true;
  }

  const mediaContainer = getMedia(element);
  const containsMediaWithIframe = Boolean(getIframe(mediaContainer));

  if (containsMediaWithIframe) {
    return isEqualBounds(
      element.getBoundingClientRect(),
      mediaContainer.getBoundingClientRect(),
      true
    );
  }

  return false;
};

const getIframeTargetElement = (element) => {
  if (!matchesMedia(element)) {
    return getMedia(element);
  }

  return element;
};

export { matchesIframeMedia, getIframeTargetElement };
